
import Vue from "vue";
export default Vue.extend({
	props: {
		name: String,
		color: String,
		active: Boolean,
		editable: Boolean
	},
	methods: {
		edit() {
			this.$emit("edit");
		},
		load() {
			this.$emit("load");
		},
		remove() {
			this.$emit("remove");
		}
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
